module.exports = __webpack_public_path__ + "static/img/img26.8535e6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img26.png
// module id = iIIL
// module chunks = 1